import { Component } from "react"
import Top from "./Top"
import Bottom from "./Bottom"
import News from "./News"
import "./index.css"
import "./News.css"
import "./PageLayout.css"

class EnterprisePage extends Component {
  componentDidMount() {
    document.documentElement.scrollTop = document.body.scrollTop = 0
  }

  render() {
    return (
      <div>
        <Top />
        <div className="page-container">
          <div className="page-header">
            <h1 className="page-title">企业践习</h1>
            <p className="page-subtitle">展示与企业合作的实践项目和学生在企业中的实习情况</p>
          </div>
          <News />
        </div>
        <Bottom />
      </div>
    )
  }
}

export default EnterprisePage